import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const updateResultPanelSlice = createSlice({
  name: "updateResultPanel",
  initialState,
  reducers: {
    updateResultPanelStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    updateResultPanelSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateResultPanelFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateResultPanelStart,
  updateResultPanelSuccess,
  updateResultPanelFailed,
} = updateResultPanelSlice.actions;

export default updateResultPanelSlice.reducer;
